import Header from './Header';
import Element from './Element';

function Noteblock() {
    return (
        <div>
            <div className="page">
                <a className="return" href={`${process.env.PUBLIC_URL}/`}><i class="fa-solid fa-left-long"></i></a>
                <div className="box">
                    <h1 className="nonimage-h1">音ブロック</h1>
                    <p>音ブロックで作成した作品を掲載しています。</p>
                    <div className="items">
                        <p><span>Minecraft</span><span>Studio One</span></p>
                    </div>
                </div>
                <div className="content">
                    {Element("https://img.youtube.com/vi/DmNUye5Y53g/mqdefault.jpg", "ロキ", "作詞・作曲: みきとP", "https://www.youtube.com/watch?v=DmNUye5Y53g", true)}
                    {Element("https://img.youtube.com/vi/sW7CbPS8w6A/mqdefault.jpg", "シャルル", "作詞・作曲: バルーン", "https://www.youtube.com/watch?v=sW7CbPS8w6A", true)}
                    {Element("https://img.youtube.com/vi/tO5NxQa2JPc/mqdefault.jpg", "残酷な天使のテーゼ", "作詞: 及川眠子 作曲: 佐藤英敏, 大森俊之", "https://www.youtube.com/watch?v=tO5NxQa2JPc", true)}
                    {Element("https://img.youtube.com/vi/hsClDt3Mh2o/mqdefault.jpg", "シオカラ節", "作曲: 藤井志帆", "https://www.youtube.com/watch?v=hsClDt3Mh2o", true)}
                </div>
            </div>
        </div>
    )
}

export default Noteblock;